import React from 'react';

export default function DarkThemeNav({
  anchor,
}) {
  const darkGrey = '/common-ui/samples/theme-dark-grey.html';
  const darkBlue = '/common-ui/samples/theme-dark-blue.html';
  return (
    <div>
      <p>
        To view this component in the either Dark Grey Theme or Dark Blue Theme, click on of the below buttons
      </p>
      <div className="grid dark-theme-nav">
        <div className="grid__col-4">
          <a className="btn" href={`${ darkGrey }#${ anchor }`}>Dark Grey Theme</a>
        </div>
        <div className="grid__col-4">
          <a className="btn" href={`${ darkBlue }#${ anchor }`}>Dark Blue Theme</a>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./styleguide/components/common/dark-theme-nav.js